export const generateEndpoint = (devEndpoint, prodEndpoint) => {
  const defaultEndpoint = process.env.REACT_APP_AWS_DEFAULT_ENDPOINT;

  const endpointSuffix = process.env.REACT_APP_ENV !== "production" ? devEndpoint : prodEndpoint;
  return `${defaultEndpoint}${endpointSuffix || ""}`;
};
